const themes: Themes = {
  default: {
    bgColor: "#222",
    borderColor: "#b5b5b5",
    selectHighlightBgColor: "#3b3b3b",
    cellBorderColor: "#474747",
    keyColor: "#ffffff",
    indexColor: "#949494",
    numberColor: "#6c99bb",
    booleanColor: "#6c99bb",
    stringColor: "#a5c261",
    objectColor: "#ffffff",
    tableHeaderBgColor: "#444",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#565a36",
  },
  dracula: {
    bgColor: "#2b2e3b",
    borderColor: "#44475a",
    selectHighlightBgColor: "#363949",
    cellBorderColor: "#44475a",
    keyColor: "#F8F8F2",
    indexColor: "#6272a4",
    numberColor: "#f1fa8c",
    booleanColor: "#ff79c6",
    stringColor: "#50FA7B",
    objectColor: "#ff79c6",
    tableHeaderBgColor: "#363949",
    tableIconColor: "#f8f8f2",
    searchHighlightBgColor: "#4c4f67",
  },
  monokai: {
    bgColor: "#272822",
    borderColor: "#49483e",
    selectHighlightBgColor: "#49483e",
    cellBorderColor: "#373a2c",
    keyColor: "#c1c1bd",
    indexColor: "#75715e",
    numberColor: "#a3e8f5",
    booleanColor: "#ae81ff",
    stringColor: "#ece393",
    objectColor: "#a6e22e",
    tableHeaderBgColor: "#414434",
    tableIconColor: "#f8f8f2",
    searchHighlightBgColor: "#72705a",
  },
  oceanicPark: {
    bgColor: "#17242B",
    borderColor: "#2c3e50",
    selectHighlightBgColor: "#345365",
    cellBorderColor: "#2b4554",
    keyColor: "#89adc2",
    indexColor: "#546e7a",
    numberColor: "#89ddff",
    booleanColor: "#35A6B3",
    stringColor: "#c3e88d",
    objectColor: "#ffcb6b",
    tableHeaderBgColor: "#2c3e50",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#185e70",
  },
  panda: {
    bgColor: "#292A2B",
    borderColor: "#4d4e50",
    selectHighlightBgColor: "#3e4042",
    cellBorderColor: "#4c4c4d",
    keyColor: "#b4fdf2",
    indexColor: "#9aedfe",
    numberColor: "#35dcfd",
    booleanColor: "#FF9AA4",
    stringColor: "#FFB857",
    objectColor: "#ff6b72",
    tableHeaderBgColor: "#3b3c3d",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#4a4d4f",
  },
  gruvboxMaterial: {
    bgColor: "#282828",
    borderColor: "#3c3836",
    selectHighlightBgColor: "#3c3836",
    cellBorderColor: "#504945",
    keyColor: "#d3869b",
    indexColor: "#bdae93",
    numberColor: "#8ec07c",
    booleanColor: "#8ec07c",
    stringColor: "#ebdbb2",
    objectColor: "#d3869b",
    tableHeaderBgColor: "#3c3836",
    tableIconColor: "#ebdbb2",
    searchHighlightBgColor: "#62564f",
  },
  tokyoNight: {
    bgColor: "#1A1B26",
    borderColor: "#272a36",
    selectHighlightBgColor: "#34374c",
    cellBorderColor: "#272a36",
    keyColor: "#C0CAF5",
    indexColor: "#89b8ff",
    numberColor: "#7CCE6A",
    booleanColor: "#7AA2F7",
    stringColor: "#AC94F7",
    objectColor: "#9d88f5",
    tableHeaderBgColor: "#363a4a",
    tableIconColor: "#f3f3f3",
    searchHighlightBgColor: "#53577b",
  },
  remedy: {
    bgColor: "#ffffff",
    borderColor: "#d3d3d3",
    selectHighlightBgColor: "#f5f5f5",
    cellBorderColor: "#eaeaea",
    keyColor: "#6e5494",
    indexColor: "#4d4d4d",
    numberColor: "#007acc",
    booleanColor: "#007acc",
    stringColor: "#2c8ebb",
    objectColor: "#6e5494",
    tableHeaderBgColor: "#f5f5f5",
    tableIconColor: "#6e5494",
    searchHighlightBgColor: "#FCEED1",
  },
  atlanticNight: {
    bgColor: "#000720",
    borderColor: "#000b33",
    selectHighlightBgColor: "#1f2647",
    cellBorderColor: "#00114d",
    keyColor: "#6cb6ff",
    indexColor: "#6cb6ff",
    numberColor: "#a2d6ff",
    booleanColor: "#a2d6ff",
    stringColor: "#BF90C9",
    objectColor: "#6cb6ff",
    tableHeaderBgColor: "#001666",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#1C2341",
  },
  defaultLight: {
    bgColor: "#f5f5f5",
    borderColor: "#d3d3d3",
    selectHighlightBgColor: "#e0e0e0",
    cellBorderColor: "#c0c0c0",
    keyColor: "#333333",
    indexColor: "#666666",
    numberColor: "#007acc",
    booleanColor: "#007acc",
    stringColor: "#2ca22c",
    objectColor: "#333333",
    tableHeaderBgColor: "#dddddd",
    tableIconColor: "#333333",
    searchHighlightBgColor: "#cccccc",
  },
  defaultLight2: {
    bgColor: "#fafafa",
    borderColor: "#e0e0e0",
    selectHighlightBgColor: "#e6e6e6",
    cellBorderColor: "#c7c7c7",
    keyColor: "#4caf50",
    indexColor: "#757575",
    numberColor: "#2196f3",
    booleanColor: "#2196f3",
    stringColor: "#ff9800",
    objectColor: "#4caf50",
    tableHeaderBgColor: "#e0e0e0",
    tableIconColor: "#333333",
    searchHighlightBgColor: "#cccccc",
  },
  slime: {
    bgColor: "#1E2324",
    borderColor: "#333333",
    selectHighlightBgColor: "#333333",
    cellBorderColor: "#444444",
    keyColor: "#8EC199",
    indexColor: "#999999",
    numberColor: "#BE9287",
    booleanColor: "#B081B9",
    stringColor: "#D88F56",
    objectColor: "#dcdcaa",
    tableHeaderBgColor: "#333333",
    tableIconColor: "#cccccc",
    searchHighlightBgColor: "#404040",
  },
  spacegray: {
    bgColor: "#212835",
    borderColor: "#2c313a",
    selectHighlightBgColor: "#2c313a",
    cellBorderColor: "#394147",
    keyColor: "#9ec7fa",
    indexColor: "#768390",
    numberColor: "#E9B672",
    booleanColor: "#D49FF4",
    stringColor: "#63F49C",
    objectColor: "#61afef",
    tableHeaderBgColor: "#2c313a",
    tableIconColor: "#e0e0e0",
    searchHighlightBgColor: "#303b4f",
  },
  blueberryDark: {
    bgColor: "#242938",
    borderColor: "#343d4a",
    selectHighlightBgColor: "#343d4a",
    cellBorderColor: "#444f5c",
    keyColor: "#ADD7FF",
    indexColor: "#8c98a6",
    numberColor: "#38B0B2",
    booleanColor: "#c3e88d",
    stringColor: "#27E8A7",
    objectColor: "#c792ea",
    tableHeaderBgColor: "#343d4a",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#30435a",
  },
  nord: {
    bgColor: "#2e3440",
    borderColor: "#3b4252",
    selectHighlightBgColor: "#363c4a",
    cellBorderColor: "#434c5e",
    keyColor: "#81a1c1",
    indexColor: "#D8DEE9",
    numberColor: "#88C0D0",
    booleanColor: "#8fbcbb",
    stringColor: "#A3BE8C",
    objectColor: "#b48ead",
    tableHeaderBgColor: "#3b4252",
    tableIconColor: "#e5e9f0",
    searchHighlightBgColor: "#404859",
  },
  nightOwl: {
    bgColor: "#011627",
    borderColor: "#02233d",
    selectHighlightBgColor: "#02233d",
    cellBorderColor: "#03314b",
    keyColor: "#dbb8e0",
    indexColor: "#dcdcaa",
    numberColor: "#F77D48",
    booleanColor: "#82aaff",
    stringColor: "#ECC48D",
    objectColor: "#ffcb6b",
    tableHeaderBgColor: "#02233d",
    tableIconColor: "#e0e0e0",
    searchHighlightBgColor: "#033963",
  },
  oneMonokai: {
    bgColor: "#282c34",
    borderColor: "#2c313a",
    selectHighlightBgColor: "#2c313a",
    cellBorderColor: "#3e4451",
    keyColor: "#abb2bf",
    indexColor: "#5c6370",
    numberColor: "#d19a66",
    booleanColor: "#61AFEF",
    stringColor: "#98c379",
    objectColor: "#61afef",
    tableHeaderBgColor: "#2c313a",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#383E4A",
  },
  cobaltNext: {
    bgColor: "#1B2B34",
    borderColor: "#234666",
    selectHighlightBgColor: "#2b333b",
    cellBorderColor: "#29546a",
    keyColor: "#dcd0e2",
    indexColor: "#dcd0e2",
    numberColor: "#5A9BCF",
    booleanColor: "#ce9178",
    stringColor: "#89C794",
    objectColor: "#d1d2d3",
    tableHeaderBgColor: "#234666",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#343D46",
  },
  shadesOfPurple: {
    bgColor: "#2d2b55",
    borderColor: "#463d69",
    selectHighlightBgColor: "#463d69",
    cellBorderColor: "#54496b",
    keyColor: "#fad000",
    indexColor: "#a599e9",
    numberColor: "#ff6188",
    booleanColor: "#ff6188",
    stringColor: "#A5FF90",
    objectColor: "#fad000",
    tableHeaderBgColor: "#463d69",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#554a82",
  },
  codeBlue: {
    bgColor: "#081620",
    borderColor: "#233544",
    selectHighlightBgColor: "#233544",
    cellBorderColor: "#194666",
    keyColor: "#B2A8B4",
    indexColor: "#96b5b4",
    numberColor: "#99cc99",
    booleanColor: "#99cc99",
    stringColor: "#d2cd87",
    objectColor: "#ff8d00",
    tableHeaderBgColor: "#233544",
    tableIconColor: "#fff",
    searchHighlightBgColor: "#233544",
  },
  softEra: {
    bgColor: "#F9F5F5",
    borderColor: "#d3d3d3",
    selectHighlightBgColor: "#E3E6ED",
    cellBorderColor: "#c0c0c0",
    keyColor: "#696462",
    indexColor: "#888888",
    numberColor: "#82B4E3",
    booleanColor: "#DA8FBD",
    stringColor: "#87B6BE",
    objectColor: "#C1AFDF",
    tableHeaderBgColor: "#E3E6ED",
    tableIconColor: "#333333",
    searchHighlightBgColor: "#d0d5e1",
  },
  atomMaterial: {
    bgColor: "#263238",
    borderColor: "#37474f",
    selectHighlightBgColor: "#37474f",
    cellBorderColor: "#546e7a",
    keyColor: "#EEFFFF",
    indexColor: "#90a4ae",
    numberColor: "#F78150",
    booleanColor: "#82b1ff",
    stringColor: "#C3E88D",
    objectColor: "#ffcb6b",
    tableHeaderBgColor: "#455a64",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#4F6875",
  },
  evaDark: {
    bgColor: "#282C34",
    borderColor: "#343c47",
    selectHighlightBgColor: "#343c47",
    cellBorderColor: "#3d4752",
    keyColor: "#B0B7C3",
    indexColor: "#5c6773",
    numberColor: "#FF9070",
    booleanColor: "#56B7C3",
    stringColor: "#82BE79",
    objectColor: "#b4be82",
    tableHeaderBgColor: "#343c47",
    tableIconColor: "#ffffff",
    searchHighlightBgColor: "#4e5765",
  },
  moonLight: {
    bgColor: "#222436",
    borderColor: "#343c47",
    selectHighlightBgColor: "#31344e",
    cellBorderColor: "#3d4752",
    keyColor: "#C8D3F5",
    indexColor: "#C8D3F5",
    numberColor: "#7CAFFF",
    booleanColor: "#FF6F78",
    stringColor: "#7AF8CA",
    objectColor: "#ff9e64",
    tableHeaderBgColor: "#31344e",
    tableIconColor: "#C8D3F5",
    searchHighlightBgColor: "#4e5765",
  },
};

export default themes;
